import { AllInvestorCategoryValues } from '@cbinsights/cbientityservice/cbientityservice';
import { request } from 'client/modules/common/utils/request';

export const getAllInvestorCategoryValues =
  (): Promise<AllInvestorCategoryValues> => {
    return request({
      url: '/service/cbientityservice/GetAllInvestorCategoryValues',
    }).then((r): AllInvestorCategoryValues => r.body);
  };
